import React, { useContext, useEffect, useState } from "react";
import { Text, Title } from "react_reusable_components";
import { useNavigate } from "react-router-dom";
import { useIntl } from "react-intl";
import { Divider } from "antd";

import { TwoColumn } from "../../core/layouts";
import variables from "../../themes/base/styles/variables";
import { AuthContext } from "../../globalContext/auth/authProvider";
import { getLocalizedMessage } from "../../UtilityFunctions/utils";
import { userRole } from "../../constants";
import { AuthService } from "../../services";
import { GlobalLoaderContext } from "../../globalContext/globalLoader/globalLoaderProvider";
import { ConversationContext } from "../../globalContext/coversation/coversationProvider";

const SwitchProfileModalContentStyle = {
  divider: {
    backgroundColor: variables.grey5,
    marginTop: variables.marginMediumSmall,
    marginBottom: variables.marginMediumSmall,
  },
  listItem: {
    display: variables.dFlex,
    alignItems: variables.alignCenter,
    cursor: "pointer",
    gap: variables.gapXS,
    padding: `${variables.paddingSmall2} ${variables.paddingHalf}`,
  },
  popoverContent: {
    width: variables.myAccountPopUpWidth,
    padding: `${variables.paddingSmall2} ${variables.paddingQuarter}`,
  },
  text: {
    fontSize: variables.fontSizeSmall,
    fontWeight: variables.fontWeightNormal,
    lineHeight: variables.lineHeightNormal,
    color: variables.turquoise,
  },
  title: {
    fontSize: variables.fontSizeSmall,
    fontWeight: variables.fontWeightNormal,
    lineHeight: variables.lineHeightNormal,
    textAlign: variables.alignCenter,
    marginBottom: 0,
    color: variables.turquoise,
  },
  checkStyle: {
    width: variables.iconWidth,
    height: variables.iconHeight,
    display: variables.dFlex,
    alignItems: variables.alignCenter,
    padding: "0.19rem",
  },
  twoColumnStyle: {
    alignItems: variables.alignCenter,
    gap: variables.gapXS3,
  },
  imageContainerStyle: {
    width: variables.iconWidth,
    height: variables.iconHeight,
  },
  backButtonStyle: {
    width: variables.iconWidth,
    height: variables.iconHeight,
    display: variables.dFlex,
    alignItems: variables.alignCenter,
    cursor: "pointer",
  },
};

export default function SwitchRoleProfileModal({
  onClose,
  currentRole,
  handleOpenChange,
}) {
  const [rolesAvailable, setRolesAvailable] = useState([]);
  const [authState, authDispatch] = useContext(AuthContext);
  const loaderDispatch = useContext(GlobalLoaderContext)[1];
  const navigate = useNavigate();
  const intl = useIntl();
  const [, conversationDispatch] = useContext(ConversationContext);

  useEffect(() => {
    if (authState?.data?.roles) {
      const filterRoles = authState?.data?.roles?.filter(
        (role) => role?.id !== userRole.DNSD
      );
      setRolesAvailable(filterRoles);
    }
  }, [authState]);

  const newRoleSelectHandler = async (role) => {
    await AuthService.switchProfile({
      dispatch: authDispatch,
      role,
      loaderDispatch,
      intl,
    }).then(() => {
      navigate("/");
      onClose();
      handleOpenChange(false);
    });

    await AuthService.getConversationTokenAndSid({
      dispatch: conversationDispatch,
      intl
    });
  };

  return (
    <div style={SwitchProfileModalContentStyle.popoverContent}>
      <TwoColumn
        style={SwitchProfileModalContentStyle.twoColumnStyle}
        leftSection={
          <img
            src={"/icons/arrow_back.svg"}
            alt="Back"
            onClick={onClose}
            style={SwitchProfileModalContentStyle.backButtonStyle}
          />
        }
        rightSection={
          <Title style={SwitchProfileModalContentStyle.title}>
            {getLocalizedMessage(intl, "switchProfile.text")}
          </Title>
        }
      />
      <Divider style={SwitchProfileModalContentStyle.divider} />
      {rolesAvailable.map((role) => (
        <div
          key={role?.name}
          style={{
            ...SwitchProfileModalContentStyle.listItem,
            ...(role?.id === currentRole?.id && {
              background: variables.red2,
            }),
          }}
          onClick={() => newRoleSelectHandler(role)}
        >
          <div style={SwitchProfileModalContentStyle.imageContainerStyle}>
            {role?.id === currentRole?.id && (
              <img
                src={"/icons/check.svg"}
                alt="Selected Role"
                style={SwitchProfileModalContentStyle.checkStyle}
              />
            )}
          </div>
          <Text style={SwitchProfileModalContentStyle.text}>
            {role?.fullName}
          </Text>
        </div>
      ))}
    </div>
  );
}
